import { render, staticRenderFns } from "./AddNickName.vue?vue&type=template&id=3073ddb4&"
import script from "./AddNickName.vue?vue&type=script&lang=js&"
export * from "./AddNickName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports